module.exports = __webpack_public_path__ + "img/474444_7B7575_9E9899_8C8C8B-256px.746cf30f.png";